/* EBH — telemetria das filas de famílias da página inicial (2026-09-21)
   ---------------------------------------------------------------------------
   Conta duas coisas por LUGAR da fila: quantas pessoas viram aquele lugar, e
   quantas lá carregaram. É o que permite responder «a posição importa?» em
   dias — cada lugar visível recebe ~500 impressões por dia, venha lá o cartão
   que vier. A pergunta «que coleção é melhor?» precisa de semanas, e a receita
   de meses; por isso a rotação não serve para descobrir a melhor coleção,
   serve para igualar as condições.

   ⚠️ O HANDLE NÃO SE LÊ DO LINK. O endereço de uma coleção é traduzido por
      língua (`/de-german/collections/<handle-de>`), por isso ler o href dava
      dez handles diferentes para a mesma coleção e a conta não somava. Quem diz
      o handle canónico é `window.EBH_MONTRA_FILAS`, escrito pelo aplicar.py a
      partir do MESMO `filas.py` que escreve os cartões.

   ⚠️ E se os dois discordarem, não se mede. Um array com outro tamanho do que o
      DOM quer dizer que alguém mexeu na fila pelo editor de temas — e dados
      trocados são piores do que dados nenhuns.

   ⚠️ A impressão conta UMA VEZ por lugar por vista de página, nunca a cada
      scroll: são 4–8 linhas por vista em vez de centenas, e o denominador passa
      a ser «quantas pessoas viram aquele lugar», que é o que a conta precisa.

   ⚠️ O id do browser é o MESMO dos favoritos (`ebh:wl:bid`) de propósito: é ele
      que já viaja para a encomenda no atributo `_ebh_wl`, e é por aí que a
      compra se casa com o clique. Um id próprio obrigava a um segundo atributo
      e a um segundo fio para manter.

   ⚠️ Medir nunca pode atrapalhar quem está a comprar: sendBeacon, sem esperar
      resposta, e falha sempre em silêncio.
   --------------------------------------------------------------------------- */
(function () {
  'use strict';

  var URL_EVENTO = '/apps/ebh/montra-evento';
  var BID_KEY = 'ebh:wl:bid';     // a MESMA chave dos favoritos — ver o aviso acima
  var CART_KEY = 'ebh:wl:cart';   // idem: uma marcação de carrinho por separador
  var ESPERA = 1200;              // junta as impressões de um scroll num pedido só

  var filas = window.EBH_MONTRA_FILAS || null;
  if (!filas) return;

  function bid() {
    var v = null;
    try { v = window.localStorage.getItem(BID_KEY); } catch (e) { v = null; }
    if (v) return v;
    v = 'b' + Date.now().toString(36) + Math.random().toString(36).slice(2, 10);
    try { window.localStorage.setItem(BID_KEY, v); } catch (e) {}
    return v;
  }

  function enviar(tipo, fila, itens) {
    if (!itens || !itens.length) return;
    var payload = JSON.stringify({
      tipo: tipo, fila: fila, itens: itens,
      largura: window.innerWidth || 0, bid: bid()
    });
    try {
      if (navigator.sendBeacon) {
        navigator.sendBeacon(URL_EVENTO, new Blob([payload], { type: 'application/json' }));
        return;
      }
    } catch (e) { /* segue para o fetch */ }
    try {
      fetch(URL_EVENTO, {
        method: 'POST', credentials: 'same-origin', keepalive: true,
        headers: { 'Content-Type': 'application/json' },
        body: payload
      }).catch(function () {});
    } catch (e) {}
  }

  /* O id do browser tem de viajar COM o carrinho: é no webhook da encomenda que
     se casa «carregou neste cartão» com «comprou». Só no CLIQUE — pôr isto numa
     impressão escrevia no carrinho de toda a gente que rola a página inicial. */
  function marcarCarrinho() {
    var ja = null;
    try { ja = window.sessionStorage.getItem(CART_KEY); } catch (e) { ja = null; }
    if (ja) return;
    try { window.sessionStorage.setItem(CART_KEY, '1'); } catch (e) {}
    try {
      fetch('/cart/update.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { _ebh_wl: bid() } })
      }).catch(function () {});
    } catch (e) {}
  }

  function ligar(nome) {
    var handles = filas[nome];
    if (!handles || !handles.length) return;

    var sec = document.querySelector('[id$="__' + nome + '"]');
    if (!sec) return;
    var cartoes = sec.querySelectorAll('.grid__inner .grid-item');
    if (cartoes.length !== handles.length) return;   // ver o aviso do cabeçalho

    /* ---- cliques ---- */
    sec.addEventListener('click', function (ev) {
      var item = ev.target && ev.target.closest && ev.target.closest('.grid-item');
      if (!item || !sec.contains(item)) return;
      var i = Array.prototype.indexOf.call(cartoes, item);
      if (i < 0) return;
      enviar('clique', nome, [{ posicao: i + 1, handle: handles[i] }]);
      marcarCarrinho();
    }, true);

    /* ---- impressões, uma vez por lugar por vista de página ---- */
    if (!('IntersectionObserver' in window)) return;
    var jaVistos = {};
    var porEnviar = [];
    var temporizador = null;

    function despachar() {
      temporizador = null;
      var lote = porEnviar;
      porEnviar = [];
      enviar('visto', nome, lote);
    }

    var olho = new IntersectionObserver(function (entradas) {
      for (var k = 0; k < entradas.length; k++) {
        var e = entradas[k];
        if (!e.isIntersecting) continue;
        var i = Array.prototype.indexOf.call(cartoes, e.target);
        if (i < 0 || jaVistos[i]) continue;
        jaVistos[i] = true;
        porEnviar.push({ posicao: i + 1, handle: handles[i] });
        olho.unobserve(e.target);
      }
      if (porEnviar.length && !temporizador) temporizador = setTimeout(despachar, ESPERA);
    }, { threshold: 0.5 });

    for (var j = 0; j < cartoes.length; j++) olho.observe(cartoes[j]);

    /* quem fecha o separador a meio do tempo de espera não se perde */
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden' && porEnviar.length) {
        if (temporizador) { clearTimeout(temporizador); }
        despachar();
      }
    });
  }

  function arrancar() {
    for (var nome in filas) {
      if (Object.prototype.hasOwnProperty.call(filas, nome)) ligar(nome);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
})();
